import { render, staticRenderFns } from "./GenericApnPricing.vue?vue&type=template&id=328ec586&scoped=true&"
import script from "./GenericApnPricing.vue?vue&type=script&lang=js&"
export * from "./GenericApnPricing.vue?vue&type=script&lang=js&"
import style0 from "./GenericApnPricing.vue?vue&type=style&index=0&id=328ec586&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ec586",
  null
  
)

export default component.exports